/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { Accordion } from 'react-accessible-accordion';
import Contact from '../shared/Contact';
import 'react-accessible-accordion/dist/minimal-example.css';

import NumberTip from '../shared/NumberTip';

import Steps from '../shared/Steps';
import CTAButton from '../shared/CTAButton';
import CTA from '../shared/CTA';
import FAQuestion from '../landing/FAQuestion';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { mp } from '../../constants/utils';
import { FAKE_RESPONSE_SAVINGS } from '../../constants/questionnaires';
import { palette, breakpoints } from '../../constants/styles';
import ProgressBar from '../shared/ProgressBar';
import { FlowHeader } from './styles';
import Title from '../shared/Title';
import Text from '../shared/Text';
import Modal from '../shared/Modal';
import ResultSubsection from '../shared/ResultSubsection';

import {
  StyledResultTableSavings,
  StyledTeamImage,
  StyledCustomDivision,
  StyledResults,
  FirstSection,
  StyledSummary,
  StyledDisclaimerBullets,
  StyledResultsDescription,
  StyledBold,
  StyledLink,
  MyCertifiedModal,
  CertifiedModalContent,
  ModalTitle,
  StyledResultDebtTitle,
  WhiteLogo,
  StyledFooter,
} from '../shared/resultsStyles';
import ConvertingModal from '../shared/ConvertingModal';
import Icon from '../shared/Icon';
import CurrentSituation from '../shared/CurrentSituation';
import QuestionSection from '../shared/QuestionSection';
import {phoneNumber} from "../../constants/constants";

const StyledPickMonths = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  margin: 0.5rem 0 0 0;
`;

const StyledPreResult = css`
  margin: 0px;
  line-height: 1.2;
`;

const StyledPreResultBottom = css`
  margin: 0px;
  min-width: 310px;
  text-align: center;
`;

const SelectorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 0.5em;
`;

const StyledBulletContainer = styled.div`
  height: 20px;
  margin-top: 0.5rem;
  width: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const StyledBullet = styled.div`
  height: 10px;
  width: 10px;
  margin: 0px;
  margin-top: 5px;
  margin-right: 10px;
  ${({ color }) =>
    color &&
    css`
      background-color: ${color};
    `}
`;

const StyledOptionsContainer = styled.div`
  width: 100%;
`;

const StyledOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const StyledInterestEarned = styled.div`
  display: flex;
  flex-direction: row;
  width: 70%;
  ${breakpoints.mobileLandscape} {
    width: 80%;
  }
`;

const StyledInterestEarnedNumber = styled.div`
  width: 30%;
  text-align: left;
  margin-left: 15px;

  ${breakpoints.mobileLandscape} {
    width: 20%;
  }
`;

const StyledResultStatementContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0.5rem 0 1.5rem 0;
`;

class Results extends Component {
  state = {
    options: [
      {
        fvTotalSavings: 0,
        pvTotalSavings: 0,
        totalInterestEarned: 0,
        totalMonthlyContributions: 0,
        percentages: {
          fvTotalSavings: 40,
          pvTotalSavings: 20,
          totalInterestEarned: 40,
        },
      },
    ],
    openModal: [false, false, false, false, false],
    yearsToSave: null,
    customMessage:
      'Hola 👋 me gustaría platicar con un experto para ver la posibilidad de cambiar mi deuda',
    openConvertingModal: false,
  };

  financialVehicles = [
    {
      name: 'Bajo el colchón',
      questions: [
        {
          question: 'Pregunta1',
          answer: 'answer1',
        },
      ],
    },
    {
      name: 'Banco',
      questions: [
        {
          question: 'Pregunta1',
          answer: 'answer1',
        },
      ],
    },
    {
      name: 'Cetes',
      questions: [
        {
          question: '¿Qué son los Cetes?',
          answer:
            'Son los “Certificados de la Tesorería de la Federación”, los cuales son emitidos por el gobierno mexicano.',
          expanded: true,
        },
        {
          question: '¿Cuál es su rendimiento?',
          answer:
            'Su rendimiento promedio es mayor que las cuentas de ahorro o cheques, pero se encuentra por debajo de la bolsa de valores y fondos de ahorro.',
        },
        {
          question: '¿Qué riesgo tiene?',
          answer:
            'Debido a que son un préstamo al gobierno mexicano, se considera como el instrumento financiero más seguro.',
        },
        {
          question: '¿Quién maneja mi dinero?',
          answer:
            'Es un préstamo, el cual el gobierno mexicano se compromete a pagar con intereses.',
        },
        {
          question: '¿Qué costo tiene?',
          answer: 'No tiene ningún costo a través de cetes-directo',
        },
      ],
      offering: true,
    },
    {
      name: 'Fondo de ahorro',
      questions: [
        {
          question: '¿Qué es un fondo de ahorro?',
          answer:
            'Es una inversión de aportaciones regulares en un portafolio diversificado diseñado para lograr tus metas. Asimismo, podría tener un componente de seguro de vida, para que en caso de fallecimiento tu pareja o familia obtengan lo que habrías ahorrado.',
          expanded: true,
        },
        {
          question: '¿Cuál es su rendimiento?',
          answer:
            'Usualmente su rendimiento promedio es mayor que Cetes debido a los beneficios de la diversificación. Sin embargo, esto dependerá de tu perfil de riesgo. ',
        },
        {
          question: '¿Qué riesgo tiene?',
          answer:
            'Dependerá del tipo de portafolio que elijas. Recuerda que a mayor riesgo, mayor rendimiento esperado.',
        },
        {
          question: '¿Quién maneja mi dinero?',
          answer: 'Una institución financiera (p.ej., Sura, Allianz, Old Mutual).',
        },
        {
          question: '¿Qué costo tiene?',
          answer:
            'Es el instrumento con mayores comisiones (estas dependerán de la institución financiera), pero los mayores beneficios por diversificación y gestión activa. ',
        },
      ],
      offering: true,
    },
    {
      name: 'Fondo de inversión',
      questions: [
        {
          question: 'Pregunta1',
          answer: 'answer1',
        },
      ],
      offering: true,
    },
    {
      name: 'Bolsa de valores',
      disabled: true,
      questions: [
        {
          question: '¿Qué es la bolsa de valores?',
          answer:
            'Es un mercado en el que se llevan a cabo las operaciones de compra/venta de acciones o deuda de empresas mexicanas.',
        },
        {
          question: '¿Cuál es su rendimiento?',
          answer:
            'Su rendimiento promedio podría ser mayor que Cetes y fondos de ahorro debido a su enfoque en títulos de valores de empresas. Sin embargo, debes tener cuidado ya que requerirás una inversión mayor para diversificar tu inversión.',
        },
        {
          question: '¿Qué riesgo tiene?',
          answer:
            'Dependerá del tipo de portafolio que construyas. Recuerda que a mayor riesgo, mayor rendimiento esperado.',
        },
        {
          question: '¿Quién maneja mi dinero?',
          answer: 'Una casa de bolsa (p.ej., GBM, Vector, Value).',
        },
        {
          question: '¿Qué costo tiene?',
          answer:
            'Dependiendo de la casa de la casa bolsa, se cobra por una comisión por transacción y por manejo de cuenta. Las comisiones son menores que en los fondos de ahorro, pero tú deberás definir dónde invertir.',
        },
      ],
    },
    {
      name: 'PPR',
      disabled: true,
      questions: [
        {
          question: '¿Qué es un Plan Personal para el Retiro (PPR)?',
          answer:
            'Es una inversión para complementar tu retiro. Se invierte en un portafolio diversificado de inversión. El ahorro es deducible de impuestos. Tú eliges el perfil de riesgo del portafolio y podrás retirar parcial o totalmente tu ahorro antes de los 65 años (menos impuestos) si así lo deseas.',
        },
        {
          question: '¿Cuál es su rendimiento?',
          answer:
            'En general, el rendimiento promedio es mayor que las Afores (a cualquier nivel de edad) debido a que no se tienen las mismas restricciones sobre dónde invertir el dinero.',
        },
        {
          question: '¿Qué riesgo tiene?',
          answer:
            'Dependerá del tipo de portafolio que elijas. Recuerda que a mayor riesgo, mayor rendimiento esperado.',
        },
        {
          question: '¿Quién maneja mi dinero?',
          answer: 'Una institución financiera (p.ej., Sura, Allianz, Old Mutual).',
        },
      ],
    },
    {
      name: 'AFORE',
      disabled: true,
      questions: [
        {
          question: '¿Qué son las aportaciones complementarias a mi Afore?',
          answer:
            'Son un apartado dentro de tu Afore para que complementes tu retiro. El ahorro es deducible de impuestos. Se invierte en un portafolio estándar y no lo podrás retirar si no hasta los 65 años.',
        },
        {
          question: '¿Cuál es su rendimiento?',
          answer:
            'Dependerá de tu edad, ya que tu ahorro se asignará un portafolio predefinido de política de inversión.',
        },
        {
          question: '¿Qué riesgo tiene?',
          answer:
            'Dependerá de tu edad, conforme menor sea tu edad mayor será el riesgo de tu portafolio predefinido.',
        },
        {
          question: '¿Quién maneja mi dinero?',
          answer: 'La Afore en la que estés registrado (p.ej., XXI Banorte, Citibanamex, Sura)',
        },
      ],
    },
  ];

  componentDidMount() {
    mp('Ahorro | Resultados | Entra');
    const { result } = this.props;
    let data = null;
    if (process.env.REACT_APP_NODE_ENV === 'development' && !result) {
      data = FAKE_RESPONSE_SAVINGS;
    } else {
      data = result;
    }
    const optionsCalculated = this.calculateSavings(data, data.years_to_save);

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      customMessage: `Hola 👋 me gustaría platicar con un experto para conocer mejor mis opciones de ahorro.\n\nMe gustaría ahorrar $${data.monthly_contribution
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} por ${
        data.years_to_save
      } años comenzando con $${data.current_savings
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.`,
      yearsToSave: data.years_to_save,
      options: optionsCalculated,
    });
  }

  componentDidUpdate = () => {
    window.onbeforeunload = () => {
      mp('Ahorro | Resultados | Se va');
    };
  };

  toggleModal = (i) => {
    const { openModal } = this.state;
    openModal[i] = !openModal[i];
    this.forceUpdate();
  };

  calculateSavings = (data, yearsToSave) => {
    const monthsToSave = yearsToSave * 12;
    const annualContributionInflationRate = data.adjusted_contribution ? 0.03 : 0;
    const monthlyContributionInflationRate = data.adjusted_contribution
      ? (1 + annualContributionInflationRate) ** (1 / 12) - 1
      : 0;
    const annualInflationRate = 0.03;
    let showDescription = '';
    const interestRate = data.annual_interest_rate;
    showDescription = `(${data.annual_interest_rate}%)`;
    const options = [
      {
        color: palette.secondaryColor,
        name: 'Tu tasa de interés',
        rate: interestRate,
        annualInterestRate: interestRate / 100,
        monthlyInterestRate: (1 + interestRate / 100) ** (1 / 12) - 1,
        showDescription,
      },
      {
        color: '#8c8c8c',
        name: 'Bajo el colchón',
        rate: 0,
        annualInterestRate: 0,
        monthlyInterestRate: 0,
        showDescription: '(0%)',
      },
      {
        color: '#8c8c8c',
        name: 'Banco',
        rate: 1.5,
        annualInterestRate: 1.5 / 100,
        monthlyInterestRate: (1 + 1.5 / 100) ** (1 / 12) - 1,
        showDescription: '(1.5%)',
      },
      {
        color: '#8c8c8c',
        name: 'CETES',
        rate: 7,
        annualInterestRate: 7 / 100,
        monthlyInterestRate: (1 + 7 / 100) ** (1 / 12) - 1,
        showDescription: '(7%)',
      },
      {
        color: '#476186',
        name: 'Fondo de ahorro',
        rate: 9,
        annualInterestRate: 9 / 100,
        monthlyInterestRate: (1 + 9 / 100) ** (1 / 12) - 1,
        showDescription: '(9%)',
      },
      {
        color: '#022759',
        name: 'Fondo de inversión',
        rate: 11,
        annualInterestRate: 11 / 100,
        monthlyInterestRate: (1 + 11 / 100) ** (1 / 12) - 1,
        showDescription: '(11%)',
      },
    ];

    let maxInterestEarned = 0;

    for (let i = 0; i < options.length; i += 1) {
      let totalMonthlyContributions = 0;
      let fvTotalSavings1 = 0;
      let fvTotalSavings2 = 0;
      let fvTotalSavings = 0;

      if (data.adjusted_contribution) {
        totalMonthlyContributions =
          (data.monthly_contribution *
            ((1 + monthlyContributionInflationRate) ** monthsToSave - 1)) /
          monthlyContributionInflationRate;
      } else {
        totalMonthlyContributions = data.monthly_contribution * monthsToSave;
      }

      if (options[i].annualInterestRate === annualInflationRate) {
        fvTotalSavings1 =
          data.current_savings * (1 + options[i].monthlyInterestRate) ** monthsToSave;
        fvTotalSavings2 =
          data.monthly_contribution *
          (1 + options[i].monthlyInterestRate) ** (monthsToSave - 1) *
          monthsToSave;
      } else {
        fvTotalSavings1 =
          data.current_savings * (1 + options[i].monthlyInterestRate) ** monthsToSave;
        fvTotalSavings2 =
          (data.monthly_contribution *
            ((1 + options[i].monthlyInterestRate) ** monthsToSave -
              (1 + monthlyContributionInflationRate) ** monthsToSave)) /
          (options[i].monthlyInterestRate - monthlyContributionInflationRate);
      }
      fvTotalSavings = fvTotalSavings1 + fvTotalSavings2;

      const totalInterestEarned = fvTotalSavings - totalMonthlyContributions - data.current_savings;
      const pvTotalSavings = fvTotalSavings / (1 + annualInflationRate) ** data.years_to_save;

      let percentages = {};
      if (i === 0) {
        percentages = {
          fvTotalSavings: (data.current_savings / fvTotalSavings) * 100,
          pvTotalSavings: (totalMonthlyContributions / fvTotalSavings) * 100,
          totalInterestEarned: (totalInterestEarned / fvTotalSavings) * 100,
        };
      }
      options[i].fvTotalSavings = fvTotalSavings;
      options[i].pvTotalSavings = pvTotalSavings;
      options[i].totalInterestEarned = totalInterestEarned;
      options[i].totalMonthlyContributions = totalMonthlyContributions;
      options[i].percentages = percentages;

      if (totalInterestEarned > maxInterestEarned) {
        maxInterestEarned = totalInterestEarned;
      }
    }

    for (let i = 0; i < options.length; i += 1) {
      if (i !== 1) {
        options[i].percentages = {
          ...options[i].percentages,
          leftBox: (options[i].totalInterestEarned * 100) / maxInterestEarned,
          rightBox: 100 - (options[i].totalInterestEarned * 100) / maxInterestEarned,
        };
      } else {
        options[i].percentages = {
          ...options[i].percentages,
          leftBox: 0,
          rightBox: 100,
        };
      }
    }
    return options;
  };

  handleChange = (value) => {
    const { yearsToSave } = this.state;
    const { result } = this.props;
    if (yearsToSave === 1 && value === -1) {
      // Do nothing
    } else if (yearsToSave === 35 && value === 1) {
      // Do nothing
    } else {
      let data = null;
      if (process.env.REACT_APP_NODE_ENV === 'development' && !result) {
        data = FAKE_RESPONSE_SAVINGS;
      } else {
        data = result;
      }
      const calcResult = this.calculateSavings(data, yearsToSave + value);

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        yearsToSave: yearsToSave + value,
        options: calcResult,
        customMessage: `Hola 👋 me gustaría platicar con un experto para conocer mejor mis opciones de ahorro.\n\nMe gustaría ahorrar $${data.monthly_contribution
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} por ${
          yearsToSave + value
        } años comenzando con $${data.current_savings
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.`,
      });
    }
  };

  render() {
    let data = null;
    const { result } = this.props;
    const { openConvertingModal, customMessage, openModal, options, yearsToSave } = this.state;
    if (process.env.REACT_APP_NODE_ENV === 'development' && !result) {
      data = FAKE_RESPONSE_SAVINGS;
    } else {
      data = result;
    }

    return (
      data && (
        <Fragment>
          <ConvertingModal
            closeCallback={() => {
              this.setState({ openConvertingModal: !openConvertingModal });
            }}
            show={openConvertingModal}
            toolName="Savings"
            customMessage={customMessage}
            stepsAction={[
              {
                content: (
                  <Fragment>
                    Registrate
                    <Link
                      style={{ color: 'blue', marginLeft: '0.3em' }}
                      to={{
                        pathname: '/registro',
                        state: {
                          customMessage,
                        },
                      }}
                    >
                      aquí
                    </Link>
                  </Fragment>
                ),
              },
              { content: 'Conoce tus opciones' },
              { content: 'Elige tu opción preferida' },
            ]}
          />
          {this.financialVehicles.map(
            (option, index) =>
              !option.disabled && (
                <Modal
                  key={`savings-modal-${option.name}`}
                  show={openModal[index]}
                  onCloseModal={() => {
                    this.toggleModal(index);
                  }}
                  styles={MyCertifiedModal}
                >
                  {() => (
                    <CertifiedModalContent>
                      <Title level={3} styles={ModalTitle}>
                        {option.name}
                      </Title>
                      <Accordion
                        accordion={false}
                        style={{
                          width: '100%',
                          marginBottom: '10px',
                          marginTop: '20px',
                          maxWidth: '750px',
                        }}
                      >
                        {option.questions.map((question) => (
                          <FAQuestion
                            key={`savings-modal-${option.name}-${question.question}`}
                            question={{
                              question: question.question,
                              answer: (
                                <StyledSummary>
                                  <Text type="body1">{question.answer}</Text>
                                </StyledSummary>
                              ),
                            }}
                            borderBottom={question.borderBottom}
                            expanded={question.expanded}
                          />
                        ))}
                      </Accordion>
                      {option.options && <Title level={3}>Conoce tus opciones</Title>}
                      {option.offering && (
                        <CTAButton
                          customMessage={`${customMessage} (Me interesó ${option.name})`}
                          linkStyles={css`
                            width: 100%;
                          `}
                          internalLink="/registro"
                          buttonText="Estoy interesado"
                          event={`Savings | ${option.name}-Modal | Estoy interesado`}
                        />
                      )}
                    </CertifiedModalContent>
                  )}
                </Modal>
              ),
          )}
          <StyledResults>
            <Fragment>
              <FlowHeader>
                <Link to="/" onClick={this.forceUpdate}>
                  <WhiteLogo src={FinautaWhiteLogo} id="logo" />
                </Link>
                <ProgressBar current={10} total={10} />
              </FlowHeader>
              <FirstSection>
                {/* Integrate to component... */}
                <CurrentSituation
                  title="Tu situación actual"
                  content={
                    <Text type="body1">
                      Quieres ahorrar
                      <StyledBold>
                        <NumberFormat
                          value={data.monthly_contribution}
                          displayType="text"
                          thousandSeparator
                          prefix="$"
                          decimalScale={0}
                        />
                      </StyledBold>{' '}
                      por <StyledBold>{yearsToSave} años</StyledBold>
                      {data.adjusted_contribution ? (
                        <Fragment>
                          . Tu ahorro mensual
                          <StyledBold> incrementará con la inflación</StyledBold>, y estarás
                        </Fragment>
                      ) : (
                        <Fragment>
                          . Tu ahorro mensual
                          <StyledBold> no incrementará con la inflación</StyledBold>, y estarás
                        </Fragment>
                      )}
                      {' obteniendo una tasa de retorno del'}
                      <StyledBold>
                        <NumberFormat
                          value={data.annual_interest_rate}
                          decimalSeparator="."
                          displayType="text"
                          decimalScale={1}
                          suffix="%"
                        />
                      </StyledBold>
                    </Text>
                  }
                />
                <StyledPickMonths>
                  <SelectorWrapper>
                    <Title level={2} styles={StyledPreResult} breakable medium>
                      En
                    </Title>
                    <Icon
                      icon="minusIcon"
                      color={palette.finautaOrange}
                      size={25}
                      style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer' }}
                      onClick={() => {
                        this.handleChange(-1);
                      }}
                    />
                    <Title
                      level={2}
                      styles={StyledPreResult}
                      breakable
                      medium
                    >{`${yearsToSave}`}</Title>
                    <Icon
                      icon="plusIcon"
                      color={palette.secondaryColor}
                      size={25}
                      style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer' }}
                      onClick={() => {
                        this.handleChange(1);
                      }}
                    />
                    <Title level={2} styles={StyledPreResult} breakable medium>
                      años
                    </Title>
                  </SelectorWrapper>
                  <Title level={2} styles={StyledPreResultBottom} breakable medium>
                    habrás ahorrado:
                  </Title>
                  <StyledResultStatementContainer>
                    <Title level={1}>
                      <StyledBold>
                        <NumberFormat
                          value={options[0].fvTotalSavings}
                          displayType="text"
                          thousandSeparator
                          prefix="$"
                          decimalScale={0}
                        />
                      </StyledBold>
                    </Title>
                    <Text type="body1">
                      Equivalente a{' '}
                      <StyledBold>
                        <NumberFormat
                          value={options[0].pvTotalSavings}
                          displayType="text"
                          thousandSeparator
                          prefix="$"
                          decimalScale={0}
                        />
                      </StyledBold>{' '}
                      de hoy
                    </Text>
                  </StyledResultStatementContainer>
                </StyledPickMonths>

                <div
                  style={{
                    height: '40px',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <div
                    style={{
                      backgroundColor: '#8c8c8c',
                      width: `${options[0].percentages.fvTotalSavings}%`,
                      height: '100%',
                    }}
                  />
                  <div
                    style={{
                      backgroundColor: palette.terciaryColor,
                      width: `${options[0].percentages.pvTotalSavings}%`,
                      height: '100%',
                    }}
                  />
                  <div
                    style={{
                      backgroundColor: palette.secondaryColor,
                      width: `${options[0].percentages.totalInterestEarned}%`,
                      height: '100%',
                    }}
                  />
                </div>

                <table
                  cellPadding={0}
                  cellSpacing={0}
                  style={{ width: '100%', margin: '15px 0px' }}
                >
                  <StyledResultTableSavings>
                    <tr>
                      <th />
                      <th />
                      <th />
                    </tr>
                    <tr>
                      <td>
                        <StyledBulletContainer>
                          <StyledBullet color="#8c8c8c" />
                        </StyledBulletContainer>
                      </td>
                      <td>
                        <Text type="body1">Empezaste con:</Text>
                      </td>
                      <td>
                        <Text type="body1" color="#8c8c8c" bold>
                          <NumberFormat
                            style={{ marginRight: '5px' }}
                            value={data.current_savings}
                            displayType="text"
                            thousandSeparator
                            prefix="$"
                            decimalScale={0}
                          />
                        </Text>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <StyledBulletContainer>
                          <StyledBullet color={palette.terciaryColor} />
                        </StyledBulletContainer>
                      </td>
                      <td>
                        <Text type="body1">Tus aportaciones suman:</Text>
                      </td>
                      <td>
                        <Text type="body1" color={palette.terciaryColor} bold>
                          <NumberFormat
                            style={{ marginRight: '5px' }}
                            value={options[0].totalMonthlyContributions}
                            displayType="text"
                            thousandSeparator
                            prefix="$"
                            decimalScale={0}
                          />
                        </Text>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <StyledBulletContainer>
                          <StyledBullet color={palette.secondaryColor} />
                        </StyledBulletContainer>
                      </td>
                      <td>
                        <Text type="body1">Crecimiento por intereses:</Text>
                      </td>
                      <td>
                        <Text type="body1" color={palette.secondaryColor} bold>
                          <NumberFormat
                            style={{ marginRight: '5px' }}
                            value={options[0].totalInterestEarned}
                            displayType="text"
                            thousandSeparator
                            prefix="$"
                            decimalScale={0}
                          />
                        </Text>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: 'none' }} />
                      <td style={{ border: 'none' }} />
                      <td style={{ borderBottom: 'none' }}>
                        <Text type="body1">
                          <StyledBold>
                            <NumberFormat
                              value={options[0].fvTotalSavings}
                              displayType="text"
                              thousandSeparator
                              prefix="$"
                              decimalScale={0}
                            />
                          </StyledBold>
                        </Text>
                      </td>
                    </tr>
                  </StyledResultTableSavings>
                </table>

                <NumberTip
                  msg1="Tip: Cambia los años dando click en los botones "
                  msg2="para ver cómo cambia tu ahorro"
                  onClick={this.handleChange}
                  arg1={-1}
                  arg2={1}
                />

                <StyledCustomDivision />

                <Title level={2} styles={StyledResultDebtTitle}>
                  ¿Dónde me conviene ahorrar?
                </Title>

                <Text type="body1">
                  Para determinar cuál te conviene, debes comparar el{' '}
                  <StyledBold>rendimiento que cada instrumento podría generar.</StyledBold> No
                  olvides que a mayor rendimiento esperado, mayor riesgo.
                </Text>
                <StyledOptionsContainer>
                  {options.map((option, index) => (
                    <Fragment key={`financial-vehicles-${option.name}`}>
                      <Title
                        level={5}
                        styles={css`
                          margin-top: 10px;
                          display: inline-block;
                        `}
                      >
                        {option.name} {option.showDescription}
                      </Title>
                      {index !== 0 && (
                        <Icon
                          icon="info"
                          color={palette.primaryColor}
                          size={15}
                          style={{ margin: '0 0.3rem 0 0.3rem', cursor: 'pointer' }}
                          onClick={() => {
                            this.toggleModal(index - 1);
                          }}
                        />
                      )}
                      <StyledOptionContainer>
                        <StyledInterestEarned>
                          <div
                            style={{
                              backgroundColor: `${option.color}`,
                              width: `${option.percentages.leftBox}%`,
                              height: '30px',
                            }}
                          />
                          <div
                            style={{
                              backgroundColor: palette.interestGray,
                              width: `${option.percentages.rightBox}%`,
                              height: '30px',
                            }}
                          />
                        </StyledInterestEarned>
                        <StyledInterestEarnedNumber>
                          <Text type="body1" color={option.color} medium>
                            {option.totalInterestEarned ? (
                              <NumberFormat
                                value={option.totalInterestEarned}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                                decimalScale={0}
                              />
                            ) : (
                              <NumberFormat
                                value={0}
                                displayType="text"
                                thousandSeparator
                                prefix="$"
                                decimalScale={0}
                              />
                            )}
                          </Text>
                        </StyledInterestEarnedNumber>
                      </StyledOptionContainer>
                    </Fragment>
                  ))}
                </StyledOptionsContainer>

                <StyledCustomDivision />

                <ResultSubsection>
                  <CTA
                    title="Quiero hacer crecer mi dinero"
                    subTitle="Nosotros te decimos cómo"
                    event="Ahorro | Empezar ahora"
                    onClick={() => {
                      this.setState({ openConvertingModal: true });
                    }}
                  />
                </ResultSubsection>

                <ResultSubsection>
                  <Title
                    level={4}
                    styles={css`
                      align-self: center;
                    `}
                    medium
                    align="center"
                  >
                    Empieza a ahorrar hoy mismo
                  </Title>
                  <Steps
                    style={{ width: '100%' }}
                    steps={[
                      {
                        content: (
                          <Fragment>
                            Registrate
                            <Link
                              style={{ color: 'blue', marginLeft: '0.3em' }}
                              to={{
                                pathname: '/registro',
                                state: {
                                  customMessage,
                                },
                              }}
                            >
                              aquí
                            </Link>
                          </Fragment>
                        ),
                      },
                      { content: 'Conoce tus opciones' },
                      { content: 'Elige tu opción preferida' },
                    ]}
                    center
                  />
                </ResultSubsection>

                <ResultSubsection>
                  <Contact
                    title="¿Todavía con dudas?"
                    subTitle="Estamos aquí para ayudarte"
                    imgUrl="https://s3.us-east-2.amazonaws.com/finauta/art/teamSmall.png"
                    event="Ahorro | Conversemos"
                    onClick={() => {
                      window.fcWidget.open();
                      window.fcWidget.show();
                    }} // TODO: Cuando volvamos a utilizar las herramientas quitar el chat
                  />
                </ResultSubsection>
              </FirstSection>
              <StyledFooter>
                <QuestionSection
                  questions={[
                    {
                      title: '¿Cómo que es gratis?',
                      answers: [
                        {
                          bullets: [
                            'La institución financiera que tú elijas para llevar a cabo tu plan nos  paga una comisión por haberte ayudado a encontrarla.',
                          ],
                        },
                      ],
                    },
                    {
                      title: 'Sobre tus resultados',
                      answers: [
                        {
                          bullets: [
                            'El objetivo de esta herramienta es asistirte en tu organización financiera y toma de decisiones',
                            'Los cálculos están basados en supuestos que han sido estimados y podrían no ser actuales o acertados',
                            'No tomes ninguna medida únicamente basado en la información proporcionada a través de esta herramienta',
                            <StyledLink
                              href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
                                customMessage,
                              )}`}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              Contacta a uno de nuestros asesores financieros certificados para
                              definir tu plan de ahorro personalizado
                            </StyledLink>,
                          ],
                        },
                      ],
                    },
                    {
                      title: 'Supuestos',
                      answers: [
                        {
                          subTitle: 'Aportaciones mensuales',
                          bullets: [
                            'Las aportaciones mensuales aumentan cada periodo con base en la inflación',
                            'Los resultados del análisis suponen que el usuario busca minimizar sus aportaciones mensuales y que estas disminuyan o permanezcan iguales en términos reales en el tiempo',
                          ],
                        },
                        {
                          subTitle: 'Inflación',
                          bullets: [
                            'La inflación promedio anual es de 3% con base en el objetivo de inflación de 3% +/- 1% del Banco de México',
                            'Las metas definidas aumentan de precio cada periodo acorde a la inflación anual',
                          ],
                        },
                        {
                          subTitle: 'Rendimiento del ahorro',
                          bullets: [
                            'El retorno nominal al ahorro se supone de 7% anual con base en rendimiento de +4% más inflación de UDIBONOS a 3 años al primer trimestre de 2019',
                            'El supuesto de retorno funge fines ilustrativos y no representa un compromiso de retorno por parte Finauta',
                          ],
                        },
                        {
                          subTitle: 'Beneficios fiscales',
                          bullets: [
                            'El análisis no internaliza el impacto de deducciones fiscales para la meta del retiro por medio del ahorro en instrumentos financieros como Afore, Plan Personal para el Retiro (PPR), o equivalentes',
                          ],
                        },
                      ],
                    },
                  ]}
                />
              </StyledFooter>
            </Fragment>
          </StyledResults>
        </Fragment>
      )
    );
  }
}

Results.propTypes = {
  result: PropTypes.object,
};

Results.defaultProps = {
  result: null,
};

export default Results;
